import type { AudioTrack } from './api.ts';

const LANGUAGE_NAMES: Record<string, string> = {
  tur: 'Türkçe',
  tr: 'Türkçe',
  eng: 'İngilizce',
  en: 'İngilizce',
  ger: 'Almanca',
  de: 'Almanca',
  fra: 'Fransızca',
  fre: 'Fransızca',
  spa: 'İspanyolca',
  es: 'İspanyolca',
  ita: 'İtalyanca',
  it: 'İtalyanca',
};

/** Türkçe parça varsa onu, yoksa ilk ses parçasını güvenli varsayılan yapar. */
export function pickDefaultAudioTrack(tracks: readonly AudioTrack[] | undefined): number {
  if (tracks === undefined || tracks.length === 0) return 0;
  const turkish = tracks.find((track) => track.language === 'tur' || track.language === 'tr');
  return turkish?.index ?? tracks[0]?.index ?? 0;
}

export function audioTrackLabel(track: AudioTrack): string {
  if (track.title !== null && track.title.length > 0) return track.title;
  const language = track.language?.toLowerCase();
  const languageName = language === undefined ? null : LANGUAGE_NAMES[language];
  if (languageName !== undefined && languageName !== null) {
    return `${languageName} (${track.codec.toUpperCase()})`;
  }
  return `${track.language?.toUpperCase() ?? 'Ses'} · ${track.codec.toUpperCase()} · ${track.channels} kanal`;
}
